<template>
  <div class="concurso-detalhes">
    <div class="page-header">
      <div class="header-left">
        <button @click="voltar" class="btn-voltar">
          <i class="fas fa-arrow-left"></i>
          Voltar
        </button>
        <div class="header-info">
          <h1 class="page-title">{{ concurso?.titulo || 'Carregando...' }}</h1>
          <p class="page-subtitle">{{ concurso?.prefeitura }} - {{ concurso?.tipo }}</p>
        </div>
      </div>
      <div class="header-right">
        <router-link :to="{ name: 'admin-concurso-editar', params: { id: $route.params.id } }" class="btn btn-primary">
          <i class="fas fa-edit"></i>
          Editar
        </router-link>
      </div>
    </div>

    <div v-if="loading" class="loading-state">
      <i class="fas fa-spinner fa-spin"></i>
      <span>Carregando detalhes do concurso...</span>
    </div>

    <div v-else-if="concurso" class="concurso-content">
      <!-- Estatísticas Resumidas -->
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-users"></i>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ concurso.inscricoes_count || 0 }}</div>
            <div class="stat-label">Inscrições</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-briefcase"></i>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ concurso.total_vagas || 0 }}</div>
            <div class="stat-label">Vagas</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-percentage"></i>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ estatisticas.total_isencoes || 0 }}</div>
            <div class="stat-label">Isenções</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-gavel"></i>
          </div>
          <div class="stat-content">
            <div class="stat-number">{{ estatisticas.total_recursos || 0 }}</div>
            <div class="stat-label">Recursos</div>
          </div>
        </div>
      </div>

      <!-- Abas de Navegação -->
      <div class="tabs-container">
        <div class="tabs-header">
          <button 
            v-for="tab in tabs" 
            :key="tab.id"
            @click="activeTab = tab.id"
            class="tab-button"
            :class="{ active: activeTab === tab.id }"
          >
            <i :class="tab.icon"></i>
            {{ tab.label }}
          </button>
        </div>

        <div class="tabs-content">
          <!-- Aba: Informações -->
          <div v-show="activeTab === 'informacoes'" class="tab-pane">
      <div class="info-card">
        <div class="card-header">
          <h3 class="card-title">
            <i class="fas fa-info-circle"></i>
            Informações Básicas
          </h3>
        </div>
        <div class="card-body">
          <div class="info-grid">
            <div class="info-item">
              <label class="info-label">Título</label>
              <span class="info-value">{{ concurso.titulo }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">Prefeitura</label>
              <span class="info-value">{{ concurso.prefeitura }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">Tipo</label>
              <span class="info-value">{{ concurso.tipo }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">Status</label>
              <span class="status-badge" :class="getStatusClass(concurso.status_inscricoes)">
                {{ concurso.status_inscricoes }}
              </span>
            </div>
            <div class="info-item">
              <label class="info-label">Data de Início</label>
              <span class="info-value">{{ formatarData(concurso.data_prazo_inicio) }}</span>
            </div>
            <div class="info-item">
              <label class="info-label">Data de Encerramento</label>
              <span class="info-value">{{ formatarData(concurso.data_prazo_fim) }}</span>
            </div>
            <div class="info-item">
                    <label class="info-label">Prazo Final para Isenção</label>
                    <span class="info-value">{{ formatarData(concurso.prazo_final_isencao) }}</span>
            </div>
            <div class="info-item">
                    <label class="info-label">Link Área do Candidato</label>
                    <a v-if="concurso.link_area_candidato" :href="concurso.link_area_candidato" target="_blank" class="info-link">
                      Acessar <i class="fas fa-external-link-alt"></i>
                    </a>
                    <span v-else class="info-value">-</span>
            </div>
          </div>
          <div v-if="concurso.descricao" class="info-item full-width">
            <label class="info-label">Descrição</label>
            <p class="info-description">{{ concurso.descricao }}</p>
                </div>
          </div>
        </div>
      </div>

          <!-- Aba: Vagas -->
          <div v-show="activeTab === 'vagas'" class="tab-pane">
            <div class="vagas-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="fas fa-briefcase"></i>
                  Vagas do Concurso
                </h3>
                <button @click="abrirModalVaga()" class="btn btn-primary">
                  <i class="fas fa-plus"></i>
                  Nova Vaga
                </button>
          </div>

              <div v-if="loadingVagas" class="loading-content">
                <i class="fas fa-spinner fa-spin"></i>
                Carregando vagas...
          </div>

              <div v-else-if="vagas.length === 0" class="empty-state">
            <i class="fas fa-briefcase"></i>
                <p>Nenhuma vaga cadastrada</p>
                <button @click="abrirModalVaga()" class="btn btn-secondary">
                  <i class="fas fa-plus"></i>
                  Cadastrar primeira vaga
                </button>
          </div>

              <div v-else class="vagas-list">
                <div v-for="vaga in vagas" :key="vaga.id" class="vaga-card">
                  <div class="vaga-header">
                    <div class="vaga-info">
                      <h4 class="vaga-titulo">{{ vaga.cargo }}</h4>
                      <div class="vaga-badges">
                        <span class="vaga-badge badge-nivel">
                          <i class="fas fa-graduation-cap"></i>
                          {{ vaga.nivel }}
                        </span>
                        <span class="vaga-badge badge-valor">
                          <i class="fas fa-dollar-sign"></i>
                          R$ {{ formatarValor(vaga.valor_inscricao) }}
                        </span>
                        <span v-if="vaga.valor_remuneracao" class="vaga-badge badge-remuneracao">
                          <i class="fas fa-money-bill-wave"></i>
                          Remuneração: R$ {{ formatarValor(vaga.valor_remuneracao) }}
                        </span>
                        <span v-if="vaga.ativo" class="vaga-badge badge-ativo">
                          <i class="fas fa-check-circle"></i>
                          Ativa
                        </span>
                        <span v-else class="vaga-badge badge-inativo">
                          <i class="fas fa-times-circle"></i>
                          Inativa
                        </span>
          </div>
        </div>
                    <div class="vaga-actions">
                      <button @click="editarVaga(vaga)" class="btn-icon btn-edit" title="Editar">
                        <i class="fas fa-edit"></i>
                      </button>
                      <button @click="excluirVaga(vaga)" class="btn-icon btn-delete" title="Excluir">
                        <i class="fas fa-trash"></i>
                      </button>
          </div>
          </div>
                  <div v-if="vaga.descricao" class="vaga-descricao">
                    {{ vaga.descricao }}
        </div>
                  <div v-if="vaga.dataVencimentoPagamento" class="vaga-vencimento">
                    <i class="fas fa-calendar-alt"></i>
                    Vencimento: {{ formatarDataNoTime(vaga.dataVencimentoPagamento) }}
          </div>
                </div>
              </div>
          </div>
          </div>

          <!-- Aba: Publicações -->
          <div v-show="activeTab === 'publicacoes'" class="tab-pane">
            <div class="publicacoes-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="fas fa-file-alt"></i>
                  Publicações do Concurso
                </h3>
                <button @click="abrirModalPublicacao()" class="btn btn-primary">
                  <i class="fas fa-plus"></i>
                  Nova Publicação
                </button>
        </div>

              <div v-if="loadingPublicacoes" class="loading-content">
                <i class="fas fa-spinner fa-spin"></i>
                Carregando publicações...
          </div>

              <div v-else-if="publicacoes.length === 0" class="empty-state">
                <i class="fas fa-file-alt"></i>
                <p>Nenhuma publicação cadastrada</p>
                <button @click="abrirModalPublicacao()" class="btn btn-secondary">
                  <i class="fas fa-plus"></i>
                  Cadastrar primeira publicação
                </button>
          </div>

              <div v-else class="publicacoes-list">
                <div v-for="publicacao in publicacoes" :key="publicacao.id" class="publicacao-card">
                  <div class="publicacao-icon">
                    <i class="fas fa-file-pdf"></i>
        </div>
                  <div class="publicacao-info">
                    <h4 class="publicacao-titulo">{{ publicacao.titulo }}</h4>
                    <p v-if="publicacao.descricao" class="publicacao-descricao">{{ publicacao.descricao }}</p>
                    <span class="publicacao-data">
                      <i class="fas fa-calendar"></i>
                      {{ formatarData(publicacao.created_at) }}
                    </span>
                  </div>
                  <div class="publicacao-actions">
                    <a v-if="publicacao.arquivo" :href="publicacao.arquivo" target="_blank" class="btn-icon btn-download" title="Download">
                      <i class="fas fa-download"></i>
                    </a>
                    <button @click="editarPublicacao(publicacao)" class="btn-icon btn-edit" title="Editar">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button @click="excluirPublicacao(publicacao)" class="btn-icon btn-delete" title="Excluir">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Aba: Prazos para Recursos -->
          <div v-show="activeTab === 'prazos-recursos'" class="tab-pane">
            <div class="prazos-section">
              <div class="section-header">
                <h3 class="section-title">
            <i class="fas fa-gavel"></i>
                  Prazos para Recursos
                </h3>
                <button @click="abrirModalPrazoRecurso()" class="btn btn-primary">
                  <i class="fas fa-plus"></i>
                  Novo Prazo
                </button>
          </div>

              <div v-if="loadingPrazosRecursos" class="loading-content">
                <i class="fas fa-spinner fa-spin"></i>
                Carregando prazos...
          </div>

              <div v-else-if="prazosRecursos.length === 0" class="empty-state">
                <i class="fas fa-gavel"></i>
                <p>Nenhum prazo de recurso cadastrado</p>
                <button @click="abrirModalPrazoRecurso()" class="btn btn-secondary">
                  <i class="fas fa-plus"></i>
                  Cadastrar primeiro prazo
                </button>
        </div>

              <div v-else class="prazos-list">
                <div v-for="prazo in prazosRecursos" :key="prazo.id" class="prazo-card">
                  <div class="prazo-header">
                    <div class="prazo-info">
                      <h4 class="prazo-titulo">{{ prazo.descricao }}</h4>
                      <div class="prazo-periodo">
                        <span class="prazo-data">
                          <i class="fas fa-calendar-start"></i>
                          {{ formatarData(prazo.data_inicio) }}
                        </span>
                        <span class="prazo-separator">até</span>
                        <span class="prazo-data">
                          <i class="fas fa-calendar-end"></i>
                          {{ formatarData(prazo.data_fim) }}
                        </span>
                      </div>
                      <div class="prazo-detalhes">
                        <span class="badge badge-info">
                          <i class="fas fa-list-ol"></i>
                          Limite: {{ prazo.quantidade_limite_envio }} envio(s)
                        </span>
                        <span v-if="prazo.exibir_n_questoes" class="badge badge-secondary">
                          <i class="fas fa-question-circle"></i>
                          Exibir número de questões
                        </span>
                      </div>
                    </div>
                    <div class="prazo-actions">
                      <button @click="editarPrazoRecurso(prazo)" class="btn-icon btn-edit" title="Editar">
                        <i class="fas fa-edit"></i>
                      </button>
                      <button @click="excluirPrazoRecurso(prazo)" class="btn-icon btn-delete" title="Excluir">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Aba: Prazos para Envios -->
          <div v-show="activeTab === 'prazos-envios'" class="tab-pane">
            <div class="prazos-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="fas fa-paper-plane"></i>
                  Prazos para Envios
                </h3>
                <button @click="abrirModalPrazoEnvio()" class="btn btn-primary">
                  <i class="fas fa-plus"></i>
                  Novo Prazo
                </button>
              </div>

              <div v-if="loadingPrazosEnvios" class="loading-content">
                <i class="fas fa-spinner fa-spin"></i>
                Carregando prazos...
              </div>

              <div v-else-if="prazosEnvios.length === 0" class="empty-state">
                <i class="fas fa-paper-plane"></i>
                <p>Nenhum prazo de envio cadastrado</p>
                <button @click="abrirModalPrazoEnvio()" class="btn btn-secondary">
                  <i class="fas fa-plus"></i>
                  Cadastrar primeiro prazo
                </button>
              </div>

              <div v-else class="prazos-list">
                <div v-for="prazo in prazosEnvios" :key="prazo.id" class="prazo-card">
                  <div class="prazo-header">
                    <div class="prazo-info">
                      <h4 class="prazo-titulo">{{ prazo.descricao }}</h4>
                      <div class="prazo-periodo">
                        <span class="prazo-data">
                          <i class="fas fa-calendar-start"></i>
                          {{ formatarData(prazo.data_inicio) }}
                        </span>
                        <span class="prazo-separator">até</span>
                        <span class="prazo-data">
                          <i class="fas fa-calendar-end"></i>
                          {{ formatarData(prazo.data_fim) }}
                        </span>
                      </div>
                      <div class="prazo-detalhes">
                        <span class="badge badge-info">
                          <i class="fas fa-list-ol"></i>
                          Limite: {{ prazo.quantidade_limite_envio }} envio(s)
                        </span>
                        <span class="badge badge-success">
                          <i class="fas fa-star"></i>
                          Pontuação: {{ prazo.pontuacao }}
                        </span>
                        <span v-if="prazo.nivel" class="badge badge-secondary">
                          <i class="fas fa-graduation-cap"></i>
                          Nível: {{ prazo.nivel }}
                        </span>
                      </div>
                    </div>
                    <div class="prazo-actions">
                      <button @click="editarPrazoEnvio(prazo)" class="btn-icon btn-edit" title="Editar">
                        <i class="fas fa-edit"></i>
                      </button>
                      <button @click="excluirPrazoEnvio(prazo)" class="btn-icon btn-delete" title="Excluir">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Aba: Convênio Bancário -->
          <div v-show="activeTab === 'convenio'" class="tab-pane">
            <div class="convenios-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="fas fa-university"></i>
                  Convênios Bancários
                </h3>
                <button @click="abrirModalConvenio()" class="btn btn-primary">
                  <i class="fas fa-plus"></i>
                  Novo Convênio
                </button>
              </div>

              <div v-if="loadingConvenios" class="loading-content">
                <i class="fas fa-spinner fa-spin"></i>
                Carregando convênios...
              </div>

              <div v-else-if="convenios.length === 0" class="empty-state">
                <i class="fas fa-university"></i>
                <p>Nenhum convênio bancário cadastrado</p>
                <button @click="abrirModalConvenio()" class="btn btn-secondary">
                  <i class="fas fa-plus"></i>
                  Cadastrar primeiro convênio
                </button>
              </div>

              <div v-else class="convenios-list">
                <div v-for="convenio in convenios" :key="convenio.id" class="convenio-card">
                  <div class="convenio-header">
                    <div class="convenio-icon">
                      <i class="fas fa-university"></i>
                    </div>
                    <div class="convenio-info">
                      <h4 class="convenio-titulo">{{ convenio.nome }}</h4>
                      <div class="convenio-detalhes">
                        <span class="badge badge-primary">{{ convenio.tipo }}</span>
                        <span class="badge" :class="convenio.status === 'Ativo' ? 'badge-success' : 'badge-secondary'">
                          {{ convenio.status }}
                        </span>
                      </div>
                      <div class="convenio-dados">
                        <span v-if="convenio.numero_convenio">
                          <i class="fas fa-hashtag"></i>
                          Convênio: {{ convenio.numero_convenio }}
                        </span>
                        <span v-if="convenio.agencia && convenio.conta">
                          <i class="fas fa-building"></i>
                          Ag: {{ convenio.agencia }} / Conta: {{ convenio.conta }}
                        </span>
                      </div>
                    </div>
                    <div class="convenio-actions">
                      <button @click="editarConvenio(convenio)" class="btn-icon btn-edit" title="Editar">
                        <i class="fas fa-edit"></i>
                      </button>
                      <button @click="excluirConvenio(convenio)" class="btn-icon btn-delete" title="Excluir">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Aba: Estatísticas -->
          <div v-show="activeTab === 'estatisticas'" class="tab-pane">
            <div class="estatisticas-detalhadas">
              <div class="stats-card">
                <h4 class="stats-title">
                  <i class="fas fa-chart-bar"></i>
                  Estatísticas Gerais
                </h4>
                <div class="stats-grid-detailed">
                  <div class="stat-item">
                    <label>Total de Inscrições</label>
                    <span>{{ estatisticas.total_inscricoes || 0 }}</span>
                  </div>
                  <div class="stat-item">
                    <label>Isenções Solicitadas</label>
                    <span>{{ estatisticas.total_isencoes || 0 }}</span>
                  </div>
                  <div class="stat-item">
                    <label>Recursos Interpostos</label>
                    <span>{{ estatisticas.total_recursos || 0 }}</span>
                  </div>
                  <div class="stat-item">
                    <label>Boletos Emitidos</label>
                    <span>{{ estatisticas.total_boletos || 0 }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="error-state">
      <i class="fas fa-exclamation-triangle"></i>
      <h3>Concurso não encontrado</h3>
      <p>O concurso solicitado não foi encontrado ou foi removido.</p>
      <button @click="voltar" class="btn btn-primary">
        <i class="fas fa-arrow-left"></i>
        Voltar para Lista
      </button>
    </div>

    <!-- Modal Vaga -->
    <div v-if="showModalVaga" class="modal-overlay" @click="fecharModalVaga">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="fas fa-briefcase"></i>
            {{ vagaEditando ? 'Editar Vaga' : 'Nova Vaga' }}
          </h4>
          <button @click="fecharModalVaga" class="modal-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Cargo *</label>
              <input v-model="formVaga.cargo" type="text" class="form-control" placeholder="Ex: Professor de Matemática" />
            </div>
            <div class="form-group">
              <label class="form-label">Nível *</label>
              <select v-model="formVaga.nivel" class="form-control">
                <option value="">Selecione</option>
                <option value="Fundamental/Elementar">Fundamental/Elementar</option>
                <option value="Médio">Médio</option>
                <option value="Técnico">Técnico</option>
                <option value="Superior">Superior</option>
                <option value="Superior/Professor">Superior/Professor</option>
                <option value="Pós-graduação">Pós-graduação</option>
              </select>
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Valor da Inscrição *</label>
              <input v-model="formVaga.valor_inscricao" type="number" step="0.01" min="0" class="form-control" placeholder="0.00" />
            </div>
            <div class="form-group">
              <label class="form-label">Valor da Remuneração</label>
              <input v-model="formVaga.valor_remuneracao" type="number" step="0.01" min="0" class="form-control" placeholder="0.00" />
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Data Vencimento Pagamento</label>
              <input v-model="formVaga.dataVencimentoPagamento" type="date" class="form-control" />
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label">Descrição</label>
            <textarea v-model="formVaga.descricao" class="form-control" rows="4" placeholder="Descrição da vaga..."></textarea>
          </div>
          
          <div class="form-group">
            <label class="form-label">
              <input v-model="formVaga.ativo" type="checkbox" />
              Vaga Ativa
            </label>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="fecharModalVaga" class="btn btn-secondary">Cancelar</button>
          <button @click="salvarVaga" class="btn btn-primary" :disabled="!formVaga.cargo || !formVaga.nivel || !formVaga.valor_inscricao">
            <i class="fas fa-save"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Publicação -->
    <div v-if="showModalPublicacao" class="modal-overlay" @click="fecharModalPublicacao">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="fas fa-file-alt"></i>
            {{ publicacaoEditando ? 'Editar Publicação' : 'Nova Publicação' }}
          </h4>
          <button @click="fecharModalPublicacao" class="modal-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Título *</label>
            <input v-model="formPublicacao.titulo" type="text" class="form-control" placeholder="Ex: Edital de Abertura" />
          </div>
          
          <div class="form-group">
            <label class="form-label">Descrição</label>
            <textarea v-model="formPublicacao.descricao" class="form-control" rows="3" placeholder="Descrição da publicação..."></textarea>
          </div>
          
          <div class="form-group">
            <label class="form-label">Upload de Arquivo</label>
            <input 
              type="file" 
              @change="handleFileUpload" 
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" 
              class="form-control"
              ref="fileInput"
            />
            <small class="form-text">Formatos aceitos: PDF, DOC, DOCX, JPG, JPEG, PNG (Máx. 5MB)</small>
          </div>

          <div v-if="formPublicacao.caminho_arquivo" class="form-group">
            <label class="form-label">Arquivo Atual</label>
            <div class="arquivo-atual">
              <i class="fas fa-file-pdf"></i>
              <a :href="formPublicacao.caminho_arquivo" target="_blank">{{ formPublicacao.arquivo || 'Visualizar arquivo' }}</a>
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label">Nome do Arquivo (opcional)</label>
            <input v-model="formPublicacao.arquivo" type="text" class="form-control" placeholder="edital.pdf" />
            <small class="form-text">Se não informado, será usado o nome do arquivo enviado</small>
          </div>
          
          <div class="form-group">
            <label class="form-label">Caminho do Arquivo (URL) - Opcional</label>
            <input v-model="formPublicacao.caminho_arquivo" type="text" class="form-control" placeholder="https://exemplo.com/arquivo.pdf" />
            <small class="form-text">Preencha apenas se quiser usar uma URL externa ao invés de fazer upload</small>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Data de Publicação</label>
              <input v-model="formPublicacao.data_publicacao" type="date" class="form-control" />
            </div>
            <div class="form-group">
              <label class="form-label">Status *</label>
              <select v-model="formPublicacao.status" class="form-control">
                <option value="Ativo">Ativo</option>
                <option value="Inativo">Inativo</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="fecharModalPublicacao" class="btn btn-secondary">Cancelar</button>
          <button @click="salvarPublicacao" class="btn btn-primary" :disabled="!formPublicacao.titulo">
            <i class="fas fa-save"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Prazo Recurso -->
    <div v-if="showModalPrazoRecurso" class="modal-overlay" @click="fecharModalPrazoRecurso">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="fas fa-gavel"></i>
            {{ prazoRecursoEditando ? 'Editar Prazo de Recurso' : 'Novo Prazo de Recurso' }}
          </h4>
          <button @click="fecharModalPrazoRecurso" class="modal-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Descrição *</label>
            <input v-model="formPrazoRecurso.descricao" type="text" class="form-control" placeholder="Ex: Recurso contra Gabarito Preliminar" />
          </div>
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Data Início *</label>
              <input v-model="formPrazoRecurso.data_inicio" type="datetime-local" class="form-control" />
            </div>
            <div class="form-group">
              <label class="form-label">Data Fim *</label>
              <input v-model="formPrazoRecurso.data_fim" type="datetime-local" class="form-control" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Limite de Envios por Candidato *</label>
              <input v-model.number="formPrazoRecurso.quantidade_limite_envio" type="number" min="1" class="form-control" />
            </div>
            <div class="form-group">
              <label class="form-label">
                <input v-model="formPrazoRecurso.exibir_n_questoes" type="checkbox" />
                Exibir número de questões
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="fecharModalPrazoRecurso" class="btn btn-secondary">Cancelar</button>
          <button @click="salvarPrazoRecurso" class="btn btn-primary" :disabled="!formPrazoRecurso.descricao || !formPrazoRecurso.data_inicio || !formPrazoRecurso.data_fim">
            <i class="fas fa-save"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Prazo Envio -->
    <div v-if="showModalPrazoEnvio" class="modal-overlay" @click="fecharModalPrazoEnvio">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="fas fa-paper-plane"></i>
            {{ prazoEnvioEditando ? 'Editar Prazo de Envio' : 'Novo Prazo de Envio' }}
          </h4>
          <button @click="fecharModalPrazoEnvio" class="modal-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="form-label">Descrição *</label>
            <input v-model="formPrazoEnvio.descricao" type="text" class="form-control" placeholder="Ex: Envio de Títulos" />
          </div>
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Data Início *</label>
              <input v-model="formPrazoEnvio.data_inicio" type="datetime-local" class="form-control" />
            </div>
            <div class="form-group">
              <label class="form-label">Data Fim *</label>
              <input v-model="formPrazoEnvio.data_fim" type="datetime-local" class="form-control" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Limite de Envios por Candidato *</label>
              <input v-model.number="formPrazoEnvio.quantidade_limite_envio" type="number" min="1" class="form-control" />
            </div>
            <div class="form-group">
              <label class="form-label">Pontuação</label>
              <input v-model.number="formPrazoEnvio.pontuacao" type="number" step="0.01" min="0" class="form-control" placeholder="0.00" />
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Nível (opcional)</label>
            <select v-model="formPrazoEnvio.nivel" class="form-control">
              <option value="">Todos os níveis</option>
              <option value="Fundamental/Elementar">Fundamental/Elementar</option>
              <option value="Médio">Médio</option>
              <option value="Técnico">Técnico</option>
              <option value="Superior">Superior</option>
              <option value="Superior/Professor">Superior/Professor</option>
              <option value="Pós-graduação">Pós-graduação</option>
            </select>
            <small class="form-text">Se selecionado, o prazo será exibido apenas para candidatos com vaga deste nível</small>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="fecharModalPrazoEnvio" class="btn btn-secondary">Cancelar</button>
          <button @click="salvarPrazoEnvio" class="btn btn-primary" :disabled="!formPrazoEnvio.descricao || !formPrazoEnvio.data_inicio || !formPrazoEnvio.data_fim">
            <i class="fas fa-save"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Convênio Bancário -->
    <div v-if="showModalConvenio" class="modal-overlay" @click="fecharModalConvenio">
      <div class="modal-content large" @click.stop>
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="fas fa-university"></i>
            {{ convenioEditando ? 'Editar Convênio Bancário' : 'Novo Convênio Bancário' }}
          </h4>
          <button @click="fecharModalConvenio" class="modal-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Nome do Convênio *</label>
              <input v-model="formConvenio.nome" type="text" class="form-control" placeholder="Ex: Banco do Brasil" />
            </div>
            <div class="form-group">
              <label class="form-label">Tipo *</label>
              <select v-model="formConvenio.tipo" class="form-control">
                <option value="BB">Banco do Brasil</option>
                <option value="ASAAS">Asaas</option>
              </select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">CNPJ Beneficiário</label>
              <input v-model="formConvenio.cnpj_beneficiario" type="text" class="form-control" placeholder="00.000.000/0000-00" />
            </div>
            <div class="form-group">
              <label class="form-label">Status *</label>
              <select v-model="formConvenio.status" class="form-control">
                <option value="Ativo">Ativo</option>
                <option value="Inativo">Inativo</option>
              </select>
            </div>
          </div>

          <!-- Campos específicos do Banco do Brasil -->
          <div v-if="formConvenio.tipo === 'BB'">
            <h5 class="form-section-title">
              <i class="fas fa-building"></i>
              Dados Bancários - Banco do Brasil
            </h5>
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Número do Convênio</label>
                <input v-model="formConvenio.numero_convenio" type="text" class="form-control" />
              </div>
              <div class="form-group">
                <label class="form-label">Carteira</label>
                <input v-model="formConvenio.carteira" type="text" class="form-control" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Variação Carteira</label>
                <input v-model="formConvenio.variacao_carteira" type="text" class="form-control" />
              </div>
              <div class="form-group">
                <label class="form-label">Agência</label>
                <input v-model="formConvenio.agencia" type="text" class="form-control" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Conta</label>
                <input v-model="formConvenio.conta" type="text" class="form-control" />
              </div>
              <div class="form-group">
                <label class="form-label">Tipo de Conta</label>
                <select v-model="formConvenio.tipo_conta" class="form-control">
                  <option value="">Selecione</option>
                  <option value="Corrente">Corrente</option>
                  <option value="Poupança">Poupança</option>
                </select>
              </div>
            </div>
            <h5 class="form-section-title">
              <i class="fas fa-code"></i>
              Configurações de API
            </h5>
            <div class="form-group">
              <label class="form-label">URL Base da API</label>
              <input v-model="formConvenio.url_base_api" type="text" class="form-control" placeholder="https://api.bb.com.br" />
            </div>
            <div class="form-row">
              <div class="form-group">
                <label class="form-label">Client ID</label>
                <input v-model="formConvenio.client_id" type="text" class="form-control" />
              </div>
              <div class="form-group">
                <label class="form-label">Client Secret</label>
                <input v-model="formConvenio.client_secret" type="password" class="form-control" />
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">OAuth URL</label>
              <input v-model="formConvenio.oauth_url" type="text" class="form-control" placeholder="https://oauth.bb.com.br/token" />
            </div>
          </div>

          <!-- Campos específicos do Asaas -->
          <div v-if="formConvenio.tipo === 'ASAAS'">
            <h5 class="form-section-title">
              <i class="fas fa-code"></i>
              Configurações de API - Asaas
            </h5>
            <div class="form-group">
              <label class="form-label">API Key *</label>
              <input v-model="formConvenio.api_key" type="password" class="form-control" placeholder="$aact_..." />
            </div>
            <div class="form-group">
              <label class="form-label">URL Base da API</label>
              <input v-model="formConvenio.url_base_api" type="text" class="form-control" placeholder="https://www.asaas.com/api/v3" />
            </div>
          </div>

          <!-- Campos comuns de Webhook -->
          <h5 class="form-section-title">
            <i class="fas fa-bell"></i>
            Configurações de Webhook
          </h5>
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Webhook URL</label>
              <input v-model="formConvenio.webhook_url" type="text" class="form-control" placeholder="https://seusite.com/webhook" />
            </div>
            <div class="form-group">
              <label class="form-label">Webhook Secret</label>
              <input v-model="formConvenio.webhook_secret" type="password" class="form-control" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="fecharModalConvenio" class="btn btn-secondary">Cancelar</button>
          <button @click="salvarConvenio" class="btn btn-primary" :disabled="!formConvenio.nome || !formConvenio.tipo">
            <i class="fas fa-save"></i>
            Salvar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ConcursoDetalhes',
  data() {
    return {
      loading: false,
      loadingVagas: false,
      loadingPublicacoes: false,
      concurso: null,
      vagas: [],
      publicacoes: [],
      estatisticas: {
        total_inscricoes: 0,
        total_isencoes: 0,
        total_recursos: 0,
        total_boletos: 0
      },
      activeTab: 'informacoes',
      tabs: [
        { id: 'informacoes', label: 'Informações', icon: 'fas fa-info-circle' },
        { id: 'vagas', label: 'Vagas', icon: 'fas fa-briefcase' },
        { id: 'publicacoes', label: 'Publicações', icon: 'fas fa-file-alt' },
        { id: 'prazos-recursos', label: 'Prazos Recursos', icon: 'fas fa-gavel' },
        { id: 'prazos-envios', label: 'Prazos Envios', icon: 'fas fa-paper-plane' },
        { id: 'convenio', label: 'Convênio Bancário', icon: 'fas fa-university' },
        { id: 'estatisticas', label: 'Estatísticas', icon: 'fas fa-chart-bar' }
      ],
      // Modal Vaga
      showModalVaga: false,
      vagaEditando: null,
      formVaga: {
        cargo: '',
        descricao: '',
        valor_inscricao: 0,
        valor_remuneracao: 0,
        nivel: '',
        dataVencimentoPagamento: '',
        ativo: true
      },
      // Modal Publicação
      showModalPublicacao: false,
      publicacaoEditando: null,
      formPublicacao: {
        titulo: '',
        descricao: '',
        arquivo: '',
        caminho_arquivo: '',
        data_publicacao: '',
        status: 'Ativo'
      },
      arquivoUpload: null,
      // Prazos Recursos
      prazosRecursos: [],
      loadingPrazosRecursos: false,
      showModalPrazoRecurso: false,
      prazoRecursoEditando: null,
      formPrazoRecurso: {
        descricao: '',
        data_inicio: '',
        data_fim: '',
        quantidade_limite_envio: 1,
        exibir_n_questoes: false
      },
      // Prazos Envios
      prazosEnvios: [],
      loadingPrazosEnvios: false,
      showModalPrazoEnvio: false,
      prazoEnvioEditando: null,
      formPrazoEnvio: {
        descricao: '',
        data_inicio: '',
        data_fim: '',
        pontuacao: 0,
        quantidade_limite_envio: 1
      },
      // Convênio Bancário
      convenios: [],
      loadingConvenios: false,
      showModalConvenio: false,
      convenioEditando: null,
      formConvenio: {
        nome: '',
        tipo: 'BB',
        cnpj_beneficiario: '',
        numero_convenio: '',
        carteira: '',
        variacao_carteira: '',
        agencia: '',
        conta: '',
        tipo_conta: '',
        url_base_api: '',
        client_id: '',
        client_secret: '',
        oauth_url: '',
        webhook_url: '',
        webhook_secret: '',
        api_key: '',
        status: 'Ativo'
      }
    }
  },
  mounted() {
    this.carregarDados()
    
    // Verificar se há uma aba específica na query
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab
    }
  },
  watch: {
    activeTab(newTab) {
      // Carregar dados das abas quando necessário
      if (newTab === 'vagas' && this.vagas.length === 0) {
        this.carregarVagas()
      } else if (newTab === 'publicacoes' && this.publicacoes.length === 0) {
        this.carregarPublicacoes()
      } else if (newTab === 'prazos-recursos' && this.prazosRecursos.length === 0) {
        this.carregarPrazosRecursos()
      } else if (newTab === 'prazos-envios' && this.prazosEnvios.length === 0) {
        this.carregarPrazosEnvios()
      } else if (newTab === 'convenio' && this.convenios.length === 0) {
        this.carregarConvenios()
      }
    }
  },
  methods: {
    async carregarDados() {
      this.loading = true
      try {
        await Promise.all([
          this.carregarConcurso(),
          this.carregarEstatisticas()
        ])
      } catch (error) {
        console.error('Erro ao carregar dados:', error)
        this.$sweet.showError('Erro ao carregar dados do concurso')
      } finally {
        this.loading = false
      }
    },
    async carregarConcurso() {
      try {
        const { data } = await axios.get(`/ps/concurso/${this.$route.params.id}`)
        this.concurso = data
      } catch (error) {
        console.error('Erro ao carregar concurso:', error)
        throw error
      }
    },
    async carregarEstatisticas() {
      try {
        const concursoId = this.$route.params.id
        
        // Buscar estatísticas de inscrições
        const inscricoes = await axios.get(`/ps/inscricao/concurso/${concursoId}`)
        
        // Buscar estatísticas de isenções
        const isencoes = await axios.get(`/ps/isencao/concurso/${concursoId}`)
        
        // Buscar estatísticas de recursos
        const recursos = await axios.get(`/ps/recurso/concurso/${concursoId}`)
        
        // Buscar estatísticas de boletos
        const boletos = await axios.get(`/ps/boleto/admin/listar`, {
          params: { concurso_id: concursoId }
        })
        
        this.estatisticas = {
          total_inscricoes: inscricoes.data?.length || 0,
          total_isencoes: isencoes.data?.length || 0,
          total_recursos: recursos.data?.length || 0,
          total_boletos: boletos.data?.length || 0
        }
      } catch (error) {
        console.error('Erro ao carregar estatísticas:', error)
        // Não lançar erro, apenas logar
      }
    },
    async carregarVagas() {
      this.loadingVagas = true
      try {
        const { data } = await axios.get(`/ps/concurso/${this.$route.params.id}/vagas`)
        this.vagas = data
      } catch (error) {
        console.error('Erro ao carregar vagas:', error)
        this.$sweet.showError('Erro ao carregar vagas')
      } finally {
        this.loadingVagas = false
      }
    },
    async carregarPublicacoes() {
      this.loadingPublicacoes = true
      try {
        const { data } = await axios.get(`/ps/concurso/${this.$route.params.id}/publicacoes`)
        this.publicacoes = data
      } catch (error) {
        console.error('Erro ao carregar publicações:', error)
        this.$sweet.showError('Erro ao carregar publicações')
      } finally {
        this.loadingPublicacoes = false
      }
    },
    // Métodos de Vagas
    abrirModalVaga(vaga = null) {
      if (vaga) {
        this.vagaEditando = vaga
        this.formVaga = {
          cargo: vaga.cargo || '',
          descricao: vaga.descricao || '',
          valor_inscricao: vaga.valor_inscricao || 0,
          valor_remuneracao: vaga.valor_remuneracao || 0,
          nivel: vaga.nivel || '',
          dataVencimentoPagamento: vaga.dataVencimentoPagamento || '',
          ativo: vaga.ativo !== undefined ? vaga.ativo : true
        }
      } else {
        this.vagaEditando = null
        this.formVaga = {
          cargo: '',
          descricao: '',
          valor_inscricao: 0,
          valor_remuneracao: 0,
          nivel: '',
          dataVencimentoPagamento: '',
          ativo: true
        }
      }
      this.showModalVaga = true
    },
    fecharModalVaga() {
      this.showModalVaga = false
      this.vagaEditando = null
      this.formVaga = {
        cargo: '',
        descricao: '',
        valor_inscricao: 0,
        nivel: '',
        dataVencimentoPagamento: '',
        ativo: true
      }
    },
    async salvarVaga() {
      if (!this.formVaga.cargo || !this.formVaga.nivel || !this.formVaga.valor_inscricao) {
        this.$sweet.showWarning('Preencha todos os campos obrigatórios')
        return
      }

      try {
        const payload = {
          ...this.formVaga,
          ativo: this.formVaga.ativo ? 1 : 0 // Converter boolean para 1/0
        }

        if (this.vagaEditando) {
          await axios.put(`/ps/concurso/vaga/${this.vagaEditando.id}`, payload)
          this.$sweet.showSuccess('Vaga atualizada com sucesso!')
        } else {
          await axios.post(`/ps/concurso/${this.$route.params.id}/vagas`, payload)
          this.$sweet.showSuccess('Vaga criada com sucesso!')
        }
        
        this.fecharModalVaga()
        this.carregarVagas()
        this.carregarConcurso() // Atualizar total de vagas
      } catch (error) {
        console.error('Erro ao salvar vaga:', error)
        this.$sweet.showError('Erro ao salvar vaga')
      }
    },
    editarVaga(vaga) {
      this.abrirModalVaga(vaga)
    },
    async excluirVaga(vaga) {
      const confirmado = await this.$sweet.showConfirm(
        'Tem certeza que deseja excluir esta vaga?',
        'Esta ação não pode ser desfeita'
      )
      
      if (!confirmado) return

      try {
        await axios.delete(`/ps/concurso/vaga/${vaga.id}`)
        this.$sweet.showSuccess('Vaga excluída com sucesso!')
        this.carregarVagas()
        this.carregarConcurso()
      } catch (error) {
        console.error('Erro ao excluir vaga:', error)
        this.$sweet.showError('Erro ao excluir vaga')
      }
    },
    // Métodos de Publicações
    abrirModalPublicacao(publicacao = null) {
      if (publicacao) {
        this.publicacaoEditando = publicacao
        this.formPublicacao = {
          titulo: publicacao.titulo || '',
          descricao: publicacao.descricao || '',
          arquivo: publicacao.arquivo || '',
          caminho_arquivo: publicacao.caminho_arquivo || '',
          data_publicacao: publicacao.data_publicacao || '',
          status: publicacao.status || 'Ativo'
        }
      } else {
        this.publicacaoEditando = null
        this.formPublicacao = {
          titulo: '',
          descricao: '',
          arquivo: '',
          caminho_arquivo: '',
          data_publicacao: '',
          status: 'Ativo'
        }
      }
      this.showModalPublicacao = true
    },
    fecharModalPublicacao() {
      this.showModalPublicacao = false
      this.publicacaoEditando = null
      this.arquivoUpload = null
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
      this.formPublicacao = {
        titulo: '',
        descricao: '',
        arquivo: '',
        caminho_arquivo: '',
        data_publicacao: '',
        status: 'Ativo'
      }
    },

    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file) {
        // Validar tamanho do arquivo (10MB)
        if (file.size > 10 * 1024 * 1024) {
          this.$sweet.showWarning('Arquivo muito grande. Tamanho máximo: 10MB')
          event.target.value = ''
          return
        }
        this.arquivoUpload = file
      }
    },
    async salvarPublicacao() {
      if (!this.formPublicacao.titulo) {
        this.$sweet.showWarning('Informe o título da publicação')
        return
      }

      try {
        // Criar FormData se houver arquivo para upload
        let payload
        let config = {}

        if (this.arquivoUpload) {
          payload = new FormData()
          payload.append('titulo', this.formPublicacao.titulo)
          payload.append('descricao', this.formPublicacao.descricao || '')
          payload.append('arquivo', this.formPublicacao.arquivo || '')
          payload.append('data_publicacao', this.formPublicacao.data_publicacao || '')
          payload.append('status', this.formPublicacao.status)
          payload.append('arquivo_upload', this.arquivoUpload)
          
          config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        } else {
          payload = this.formPublicacao
        }

        if (this.publicacaoEditando) {
          await axios.put(`/ps/concurso/publicacao/${this.publicacaoEditando.id}`, payload, config)
          this.$sweet.showSuccess('Publicação atualizada com sucesso!')
        } else {
          await axios.post(`/ps/concurso/${this.$route.params.id}/publicacoes`, payload, config)
          this.$sweet.showSuccess('Publicação criada com sucesso!')
        }
        
        this.fecharModalPublicacao()
        this.carregarPublicacoes()
      } catch (error) {
        console.error('Erro ao salvar publicação:', error)
        const errorMessage = error.response?.data?.error || 'Erro ao salvar publicação'
        this.$sweet.showError(errorMessage)
      }
    },
    editarPublicacao(publicacao) {
      this.abrirModalPublicacao(publicacao)
    },
    async excluirPublicacao(publicacao) {
      const confirmado = await this.$sweet.showConfirm(
        'Tem certeza que deseja excluir esta publicação?',
        'Esta ação não pode ser desfeita'
      )
      
      if (!confirmado) return

      try {
        await axios.delete(`/ps/concurso/publicacao/${publicacao.id}`)
        this.$sweet.showSuccess('Publicação excluída com sucesso!')
        this.carregarPublicacoes()
      } catch (error) {
        console.error('Erro ao excluir publicação:', error)
        this.$sweet.showError('Erro ao excluir publicação')
      }
    },
    // Métodos de Prazos de Recursos
    async carregarPrazosRecursos() {
      this.loadingPrazosRecursos = true
      try {
        const { data } = await axios.get(`/ps/recurso/prazos`, {
          params: { concurso_id: this.$route.params.id }
        })
        this.prazosRecursos = data
      } catch (error) {
        console.error('Erro ao carregar prazos de recursos:', error)
        this.$sweet.showError('Erro ao carregar prazos de recursos')
      } finally {
        this.loadingPrazosRecursos = false
      }
    },

    abrirModalPrazoRecurso(prazo = null) {
      if (prazo) {
        this.prazoRecursoEditando = prazo
        this.formPrazoRecurso = {
          descricao: prazo.descricao || '',
          data_inicio: this.formatDateTimeForInput(prazo.data_inicio),
          data_fim: this.formatDateTimeForInput(prazo.data_fim),
          quantidade_limite_envio: prazo.quantidade_limite_envio || 1,
          exibir_n_questoes: !!prazo.exibir_n_questoes
        }
      } else {
        this.prazoRecursoEditando = null
        this.formPrazoRecurso = {
          descricao: '',
          data_inicio: '',
          data_fim: '',
          quantidade_limite_envio: 1,
          exibir_n_questoes: false
        }
      }
      this.showModalPrazoRecurso = true
    },

    fecharModalPrazoRecurso() {
      this.showModalPrazoRecurso = false
      this.prazoRecursoEditando = null
    },

    async salvarPrazoRecurso() {
      if (!this.formPrazoRecurso.descricao || !this.formPrazoRecurso.data_inicio || !this.formPrazoRecurso.data_fim) {
        this.$sweet.showWarning('Preencha todos os campos obrigatórios')
        return
      }

      try {
        const payload = {
          ...this.formPrazoRecurso,
          data_inicio: this.convertDateTimeLocalToISO(this.formPrazoRecurso.data_inicio),
          data_fim: this.convertDateTimeLocalToISO(this.formPrazoRecurso.data_fim),
          concurso_id: this.$route.params.id
        }

        if (this.prazoRecursoEditando) {
          await axios.put(`/ps/recurso/prazos/${this.prazoRecursoEditando.id}`, payload)
          this.$sweet.showSuccess('Prazo de recurso atualizado com sucesso!')
        } else {
          await axios.post(`/ps/recurso/prazos`, payload)
          this.$sweet.showSuccess('Prazo de recurso criado com sucesso!')
        }
        
        this.fecharModalPrazoRecurso()
        this.carregarPrazosRecursos()
      } catch (error) {
        console.error('Erro ao salvar prazo de recurso:', error)
        this.$sweet.showError('Erro ao salvar prazo de recurso')
      }
    },

    editarPrazoRecurso(prazo) {
      this.abrirModalPrazoRecurso(prazo)
    },

    async excluirPrazoRecurso(prazo) {
      const confirmado = await this.$sweet.showConfirm(
        'Tem certeza que deseja excluir este prazo de recurso?',
        'Esta ação não pode ser desfeita'
      )
      
      if (!confirmado) return

      try {
        await axios.delete(`/ps/recurso/prazos/${prazo.id}`)
        this.$sweet.showSuccess('Prazo de recurso excluído com sucesso!')
        this.carregarPrazosRecursos()
      } catch (error) {
        console.error('Erro ao excluir prazo de recurso:', error)
        this.$sweet.showError('Erro ao excluir prazo de recurso')
      }
    },

    // Métodos de Prazos de Envios
    async carregarPrazosEnvios() {
      this.loadingPrazosEnvios = true
      try {
        const { data } = await axios.get(`/ps/envio/prazos`, {
          params: { concurso_id: this.$route.params.id }
        })
        this.prazosEnvios = data
      } catch (error) {
        console.error('Erro ao carregar prazos de envios:', error)
        this.$sweet.showError('Erro ao carregar prazos de envios')
      } finally {
        this.loadingPrazosEnvios = false
      }
    },

    abrirModalPrazoEnvio(prazo = null) {
      if (prazo) {
        this.prazoEnvioEditando = prazo
        this.formPrazoEnvio = {
          descricao: prazo.descricao || '',
          data_inicio: this.formatDateTimeForInput(prazo.data_inicio),
          data_fim: this.formatDateTimeForInput(prazo.data_fim),
          pontuacao: prazo.pontuacao || 0,
          quantidade_limite_envio: prazo.quantidade_limite_envio || 1,
          nivel: prazo.nivel || ''
        }
      } else {
        this.prazoEnvioEditando = null
        this.formPrazoEnvio = {
          descricao: '',
          data_inicio: '',
          data_fim: '',
          pontuacao: 0,
          quantidade_limite_envio: 1,
          nivel: ''
        }
      }
      this.showModalPrazoEnvio = true
    },

    fecharModalPrazoEnvio() {
      this.showModalPrazoEnvio = false
      this.prazoEnvioEditando = null
    },

    async salvarPrazoEnvio() {
      if (!this.formPrazoEnvio.descricao || !this.formPrazoEnvio.data_inicio || !this.formPrazoEnvio.data_fim) {
        this.$sweet.showWarning('Preencha todos os campos obrigatórios')
        return
      }

      try {
        const payload = {
          ...this.formPrazoEnvio,
          data_inicio: this.convertDateTimeLocalToISO(this.formPrazoEnvio.data_inicio),
          data_fim: this.convertDateTimeLocalToISO(this.formPrazoEnvio.data_fim),
          concurso_id: this.$route.params.id
        }

        if (this.prazoEnvioEditando) {
          await axios.put(`/ps/envio/prazos/${this.prazoEnvioEditando.id}`, payload)
          this.$sweet.showSuccess('Prazo de envio atualizado com sucesso!')
        } else {
          await axios.post(`/ps/envio/prazos`, payload)
          this.$sweet.showSuccess('Prazo de envio criado com sucesso!')
        }
        
        this.fecharModalPrazoEnvio()
        this.carregarPrazosEnvios()
      } catch (error) {
        console.error('Erro ao salvar prazo de envio:', error)
        this.$sweet.showError('Erro ao salvar prazo de envio')
      }
    },

    editarPrazoEnvio(prazo) {
      this.abrirModalPrazoEnvio(prazo)
    },

    async excluirPrazoEnvio(prazo) {
      const confirmado = await this.$sweet.showConfirm(
        'Tem certeza que deseja excluir este prazo de envio?',
        'Esta ação não pode ser desfeita'
      )
      
      if (!confirmado) return

      try {
        await axios.delete(`/ps/envio/prazos/${prazo.id}`)
        this.$sweet.showSuccess('Prazo de envio excluído com sucesso!')
        this.carregarPrazosEnvios()
      } catch (error) {
        console.error('Erro ao excluir prazo de envio:', error)
        this.$sweet.showError('Erro ao excluir prazo de envio')
      }
    },

    // Métodos de Convênios Bancários
    async carregarConvenios() {
      this.loadingConvenios = true
      try {
        const { data } = await axios.get(`/ps/concurso/${this.$route.params.id}/convenios`)
        this.convenios = data
      } catch (error) {
        console.error('Erro ao carregar convênios:', error)
        this.$sweet.showError('Erro ao carregar convênios')
      } finally {
        this.loadingConvenios = false
      }
    },

    abrirModalConvenio(convenio = null) {
      if (convenio) {
        this.convenioEditando = convenio
        this.formConvenio = { ...convenio }
      } else {
        this.convenioEditando = null
        this.formConvenio = {
          nome: '',
          tipo: 'BB',
          cnpj_beneficiario: '',
          numero_convenio: '',
          carteira: '',
          variacao_carteira: '',
          agencia: '',
          conta: '',
          tipo_conta: '',
          url_base_api: '',
          client_id: '',
          client_secret: '',
          oauth_url: '',
          webhook_url: '',
          webhook_secret: '',
          api_key: '',
          status: 'Ativo'
        }
      }
      this.showModalConvenio = true
    },

    fecharModalConvenio() {
      this.showModalConvenio = false
      this.convenioEditando = null
    },

    async salvarConvenio() {
      if (!this.formConvenio.nome || !this.formConvenio.tipo) {
        this.$sweet.showWarning('Preencha todos os campos obrigatórios')
        return
      }

      try {
        if (this.convenioEditando) {
          await axios.put(`/ps/concurso/convenio/${this.convenioEditando.id}`, this.formConvenio)
          this.$sweet.showSuccess('Convênio bancário atualizado com sucesso!')
        } else {
          await axios.post(`/ps/concurso/${this.$route.params.id}/convenio`, this.formConvenio)
          this.$sweet.showSuccess('Convênio bancário criado com sucesso!')
        }
        
        this.fecharModalConvenio()
        this.carregarConvenios()
      } catch (error) {
        console.error('Erro ao salvar convênio:', error)
        this.$sweet.showError('Erro ao salvar convênio')
      }
    },

    editarConvenio(convenio) {
      this.abrirModalConvenio(convenio)
    },

    async excluirConvenio(convenio) {
      const confirmado = await this.$sweet.showConfirm(
        'Tem certeza que deseja excluir este convênio bancário?',
        'Esta ação não pode ser desfeita'
      )
      
      if (!confirmado) return

      try {
        await axios.delete(`/ps/concurso/convenio/${convenio.id}`)
        this.$sweet.showSuccess('Convênio bancário excluído com sucesso!')
        this.carregarConvenios()
      } catch (error) {
        console.error('Erro ao excluir convênio:', error)
        this.$sweet.showError('Erro ao excluir convênio')
      }
    },

    // Métodos Auxiliares
    voltar() {
      this.$router.push({ name: 'admin-concursos' })
    },
    getStatusClass(status) {
      const classes = {
        'ABERTAS': 'status-abertas',
        'ENCERRADAS': 'status-encerradas',
        'AGUARDANDO': 'status-aguardando'
      }
      return classes[status] || 'status-default'
    },
    formatarData(data) {
      if (!data) return '-'
      
      // Se a data vem no formato YYYY-MM-DD (sem horário), extrair diretamente
      if (typeof data === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
        const [year, month, day] = data.split('-')
        return `${day}/${month}/${year}`
      }
      
      // Extrair diretamente da string ISO sem usar new Date() para evitar conversão de timezone
      if (typeof data === 'string' && data.includes('T')) {
        const parts = data.split('T')
        if (parts.length === 2) {
          const [datePart, timePart] = parts
          const [year, month, day] = datePart.split('-')
          // Remover informações de timezone (Z, +03:00, etc) e pegar apenas hora:minuto
          const timeClean = timePart.replace(/[Z+-].*$/, '')
          const [hours, minutes] = timeClean.split(':')
          return `${day}/${month}/${year} ${hours}:${minutes}`
        }
      }
      
      // Fallback: tentar usar new Date() se não for formato ISO
      try {
        const date = new Date(data)
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        return `${day}/${month}/${year} ${hours}:${minutes}`
      } catch {
        return data
      }
    },
    formatarDataNoTime(data) {
      if (!data) return '-'
      
      // Se a data vem no formato YYYY-MM-DD (sem horário), extrair diretamente
      if (typeof data === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(data)) {
        const [year, month, day] = data.split('-')
        return `${day}/${month}/${year}`
      }
      
      // Extrair diretamente da string ISO sem usar new Date() para evitar conversão de timezone
      if (typeof data === 'string' && data.includes('T')) {
        const parts = data.split('T')
        if (parts.length === 2) {
          const [datePart] = parts
          const [year, month, day] = datePart.split('-')
          return `${day}/${month}/${year}`
        }
      }
      
      // Fallback: tentar usar new Date() se não for formato ISO
      try {
        const date = new Date(data)
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        return `${day}/${month}/${year}`
      } catch {
        return data
      }
    },
    formatarValor(valor) {
      if (!valor && valor !== 0) return '0,00'
      return parseFloat(valor).toFixed(2).replace('.', ',')
    },
    formatDateTimeForInput(dateTime) {
      if (!dateTime) return ''
      
      // Tratar formato do banco: YYYY-MM-DD HH:mm:ss (com espaço)
      if (typeof dateTime === 'string') {
        let dateString = dateTime.replace('Z', '')
        
        // Se tiver formato com espaço (formato do banco: YYYY-MM-DD HH:mm:ss)
        if (dateString.match(/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}/)) {
          const [datePart, timePart] = dateString.split(' ')
          const [hours, minutes] = timePart.split(':')
          // Retornar no formato datetime-local (YYYY-MM-DDTHH:mm)
          return `${datePart}T${hours}:${minutes}`
        }
        
        // Extrair diretamente da string ISO sem usar new Date() para evitar conversão de timezone
        if (dateString.includes('T')) {
          const parts = dateString.split('T')
          if (parts.length === 2) {
            const [datePart, timePart] = parts
            // Remover informações de timezone (Z, +03:00, etc) e pegar apenas hora:minuto
            const timeClean = timePart.replace(/[Z+-].*$/, '')
            const [hours, minutes] = timeClean.split(':')
            // Retornar no formato datetime-local (YYYY-MM-DDTHH:mm)
            return `${datePart}T${hours}:${minutes}`
          }
        }
      }
      
      // Fallback: tentar usar new Date() se não for formato conhecido
      try {
        const date = new Date(dateTime)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        return `${year}-${month}-${day}T${hours}:${minutes}`
      } catch {
        return ''
      }
    },
    convertDateTimeLocalToISO(dateTimeLocal) {
      if (!dateTimeLocal) return null
      
      // O formato datetime-local é: "YYYY-MM-DDTHH:mm"
      // Problema: new Date().toISOString() converte para UTC, alterando o horário
      // Solução: Construir a string ISO manualmente preservando o horário exato digitado
      
      // Se a string já tem o formato completo, usar diretamente
      if (dateTimeLocal.includes(':')) {
        const parts = dateTimeLocal.split('T')
        if (parts.length === 2) {
          const [datePart, timePart] = parts
          // Garantir que tem segundos e milissegundos
          const timeWithSeconds = timePart.includes(':') && timePart.split(':').length === 2 
            ? `${timePart}:00` 
            : timePart
          // Retornar no formato ISO preservando o horário exato
          return `${datePart}T${timeWithSeconds}.000Z`
        }
      }
      
      // Fallback: usar o método anterior se o formato não for o esperado
      const localDate = new Date(dateTimeLocal)
      const timezoneOffset = localDate.getTimezoneOffset()
      const adjustedDate = new Date(localDate.getTime() + (timezoneOffset * 60 * 1000))
      return adjustedDate.toISOString()
    }
  }
}
</script>

<style lang="scss" scoped>
.concurso-detalhes {
  .page-header {
    background: white;
    border-radius: 15px;
    padding: 25px 30px;
    margin-bottom: 20px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-left {
      display: flex;
      align-items: center;
      gap: 20px;

      .btn-voltar {
        background: #f8f9fa;
        border: 1px solid #e9ecef;
        color: #6c757d;
        padding: 10px 15px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;

        &:hover {
          background: #e9ecef;
          color: #495057;
        }
      }

      .header-info {
        .page-title {
          margin: 0 0 5px 0;
          font-size: 24px;
          font-weight: 600;
          color: #2c3e50;
        }

        .page-subtitle {
          margin: 0;
          font-size: 14px;
          color: #6c757d;
        }
      }
    }
  }

  .loading-state,
  .error-state {
    text-align: center;
    padding: 60px 30px;
    color: #6c757d;

    i {
      font-size: 48px;
      margin-bottom: 20px;
      opacity: 0.5;
    }

    h3 {
      margin: 0 0 10px 0;
      color: #495057;
    }

    p {
      margin: 0 0 20px 0;
    }
  }

  .concurso-content {
    .stats-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 20px;
      margin-bottom: 20px;

      .stat-card {
      background: white;
      border-radius: 15px;
        padding: 25px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
      border: 1px solid rgba(0, 0, 0, 0.05);
        display: flex;
        align-items: center;
        gap: 20px;

        .stat-icon {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 20px;
        }

        .stat-content {
          .stat-number {
            font-size: 24px;
            font-weight: 700;
            color: #2c3e50;
            margin-bottom: 5px;
          }

          .stat-label {
            font-size: 14px;
            color: #6c757d;
            font-weight: 500;
          }
        }
      }
    }

    .tabs-container {
      background: white;
      border-radius: 15px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
      border: 1px solid rgba(0, 0, 0, 0.05);
      overflow: hidden;

      .tabs-header {
        display: flex;
        border-bottom: 2px solid #e9ecef;
        background: #f8f9fa;

        .tab-button {
          flex: 1;
          padding: 15px 20px;
          background: transparent;
          border: none;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          color: #6c757d;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all 0.3s ease;
          border-bottom: 3px solid transparent;

          i {
            font-size: 16px;
          }

          &:hover {
            background: rgba(102, 126, 234, 0.05);
            color: #667eea;
          }

          &.active {
            color: #667eea;
            background: white;
            border-bottom-color: #667eea;
          }
        }
      }

      .tabs-content {
        padding: 30px;

        .tab-pane {
          animation: fadeIn 0.3s ease-in;
        }
      }
    }

    .info-card {
      .card-header {
        background: #f8f9fa;
        padding: 20px 25px;
        border-bottom: 1px solid #e9ecef;

        .card-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          display: flex;
          align-items: center;
          gap: 10px;

          i {
            color: #667eea;
          }
        }
      }

      .card-body {
        padding: 25px;

        .info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
        }

        .info-item {
          &.full-width {
            grid-column: 1 / -1;
            margin-top: 10px;
          }

          .info-label {
            display: block;
            font-weight: 600;
            color: #495057;
            margin-bottom: 5px;
            font-size: 14px;
          }

          .info-value {
            font-size: 16px;
            color: #2c3e50;
          }

          .info-link {
            color: #667eea;
            text-decoration: none;
            font-size: 14px;
            display: inline-flex;
            align-items: center;
            gap: 5px;
            
            &:hover {
              text-decoration: underline;
            }
          }

          .info-description {
            margin: 0;
            line-height: 1.6;
            color: #495057;
          }
        }
      }
    }

    // Vagas Section
    .vagas-section,
    .publicacoes-section {
      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 25px;

        .section-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          display: flex;
          align-items: center;
          gap: 10px;

          i {
            color: #667eea;
          }
        }
      }

      .loading-content,
      .empty-state {
        text-align: center;
        padding: 40px 20px;
        color: #6c757d;

        i {
          font-size: 48px;
          margin-bottom: 15px;
          opacity: 0.5;
        }

        p {
          margin-bottom: 20px;
        }
      }

      .vagas-list,
      .publicacoes-list {
      display: grid;
        gap: 15px;
      }

      .vaga-card {
        background: #f8f9fa;
        border-radius: 10px;
        padding: 20px;
        border: 1px solid #e9ecef;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
        }

        .vaga-header {
        display: flex;
          justify-content: space-between;
          align-items: start;
          margin-bottom: 10px;

          .vaga-info {
            flex: 1;

            .vaga-titulo {
              margin: 0 0 8px 0;
              font-size: 16px;
              font-weight: 600;
              color: #2c3e50;
            }

            .vaga-badges {
              display: flex;
              gap: 8px;
              flex-wrap: wrap;
              margin-top: 8px;

              .vaga-badge {
                display: inline-flex;
        align-items: center;
                gap: 5px;
                padding: 4px 10px;
                border-radius: 12px;
                font-size: 12px;
                font-weight: 500;

                i {
                  font-size: 11px;
                }

                &.badge-nivel {
                  background: rgba(102, 126, 234, 0.1);
                  color: #667eea;
                }

                &.badge-valor {
                  background: rgba(40, 167, 69, 0.1);
                  color: #28a745;
                }

                &.badge-remuneracao {
                  background: rgba(23, 162, 184, 0.1);
                  color: #17a2b8;
                }

                &.badge-ativo {
                  background: rgba(40, 167, 69, 0.1);
                  color: #28a745;
                }

                &.badge-inativo {
                  background: rgba(220, 53, 69, 0.1);
                  color: #dc3545;
                }
              }
            }
          }

          .vaga-actions {
            display: flex;
            gap: 5px;
          }
        }

        .vaga-descricao {
          color: #6c757d;
          font-size: 14px;
          line-height: 1.5;
          margin-top: 10px;
          padding-top: 10px;
          border-top: 1px solid #e9ecef;
        }

        .vaga-vencimento {
          color: #6c757d;
          font-size: 13px;
          margin-top: 8px;
          display: flex;
          align-items: center;
          gap: 5px;

          i {
            color: #ffc107;
          }
        }
      }

      .publicacao-card {
        background: #f8f9fa;
        border-radius: 10px;
        padding: 20px;
        border: 1px solid #e9ecef;
        display: flex;
        align-items: center;
        gap: 15px;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
        }

        .publicacao-icon {
          width: 50px;
          height: 50px;
          border-radius: 10px;
          background: rgba(220, 53, 69, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #dc3545;
          font-size: 24px;
        }

        .publicacao-info {
          flex: 1;

          .publicacao-titulo {
            margin: 0 0 5px 0;
            font-size: 16px;
            font-weight: 600;
            color: #2c3e50;
          }

          .publicacao-descricao {
            margin: 0 0 8px 0;
            color: #6c757d;
            font-size: 14px;
          }

          .publicacao-data {
            display: inline-flex;
            align-items: center;
            gap: 5px;
            color: #6c757d;
            font-size: 12px;

            i {
              font-size: 11px;
            }
          }
        }

        .publicacao-actions {
          display: flex;
          gap: 5px;
        }
      }
    }

    // Prazos Section
    .prazos-section,
    .convenios-section {
      .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 25px;

        .section-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          display: flex;
          align-items: center;
          gap: 10px;

          i {
            color: #667eea;
          }
        }
      }

      .loading-content,
      .empty-state {
        text-align: center;
        padding: 40px 20px;
        color: #6c757d;

        i {
          font-size: 48px;
          margin-bottom: 15px;
          opacity: 0.5;
        }

        p {
          margin-bottom: 20px;
        }
      }

      .prazos-list,
      .convenios-list {
        display: grid;
        gap: 15px;
      }

      .prazo-card {
        background: #f8f9fa;
        border-radius: 10px;
        padding: 20px;
        border: 1px solid #e9ecef;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
        }

        .prazo-header {
          display: flex;
          justify-content: space-between;
          align-items: start;

          .prazo-info {
            flex: 1;

            .prazo-titulo {
              margin: 0 0 10px 0;
              font-size: 16px;
              font-weight: 600;
              color: #2c3e50;
            }

            .prazo-periodo {
              display: flex;
              align-items: center;
              gap: 10px;
              margin-bottom: 10px;

              .prazo-data {
                display: inline-flex;
                align-items: center;
                gap: 5px;
                color: #495057;
                font-size: 14px;

                i {
                  color: #667eea;
                  font-size: 12px;
                }
              }

              .prazo-separator {
                color: #6c757d;
                font-size: 12px;
              }
            }

            .prazo-detalhes {
              display: flex;
              gap: 8px;
              flex-wrap: wrap;

              .badge {
                font-size: 12px;
                padding: 4px 10px;
                border-radius: 12px;
            font-weight: 500;
                display: inline-flex;
                align-items: center;
                gap: 4px;

                i {
                  font-size: 10px;
                }

                &.badge-info {
                  background: rgba(23, 162, 184, 0.1);
                  color: #17a2b8;
                }

                &.badge-secondary {
                  background: rgba(108, 117, 125, 0.1);
                  color: #6c757d;
                }

                &.badge-success {
                  background: rgba(40, 167, 69, 0.1);
                  color: #28a745;
                }
              }
            }
          }

          .prazo-actions {
            display: flex;
            gap: 5px;
          }
        }
      }

      .convenio-card {
        background: #f8f9fa;
        border-radius: 10px;
        padding: 20px;
        border: 1px solid #e9ecef;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
        }

        .convenio-header {
          display: flex;
          gap: 15px;
          align-items: start;

          .convenio-icon {
            width: 50px;
            height: 50px;
            border-radius: 10px;
            background: rgba(102, 126, 234, 0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #667eea;
            font-size: 24px;
            flex-shrink: 0;
          }

          .convenio-info {
            flex: 1;

            .convenio-titulo {
              margin: 0 0 8px 0;
              font-size: 16px;
              font-weight: 600;
              color: #2c3e50;
            }

            .convenio-detalhes {
              display: flex;
              gap: 8px;
              margin-bottom: 8px;

              .badge {
                font-size: 12px;
                padding: 4px 10px;
                border-radius: 12px;
                font-weight: 500;

                &.badge-primary {
                  background: rgba(102, 126, 234, 0.1);
                  color: #667eea;
                }

                &.badge-success {
                  background: rgba(40, 167, 69, 0.1);
                  color: #28a745;
                }

                &.badge-secondary {
                  background: rgba(108, 117, 125, 0.1);
                  color: #6c757d;
                }
              }
            }

            .convenio-dados {
              display: flex;
              flex-direction: column;
              gap: 4px;
              color: #6c757d;
              font-size: 13px;

              span {
                display: flex;
                align-items: center;
                gap: 5px;

                i {
                  font-size: 11px;
                  color: #667eea;
                }
              }
            }
          }

          .convenio-actions {
            display: flex;
            gap: 5px;
            flex-shrink: 0;
          }
        }
      }
    }

    // Estatísticas Detalhadas
    .estatisticas-detalhadas {
      .stats-card {
        background: #f8f9fa;
        border-radius: 10px;
        padding: 25px;

        .stats-title {
          margin: 0 0 20px 0;
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          display: flex;
          align-items: center;
          gap: 10px;

          i {
            color: #667eea;
          }
        }

        .stats-grid-detailed {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;

          .stat-item {
            background: white;
            padding: 20px;
            border-radius: 10px;
            border: 1px solid #e9ecef;

            label {
              display: block;
              font-weight: 600;
              color: #495057;
              margin-bottom: 10px;
              font-size: 14px;
            }

            span {
              font-size: 28px;
              font-weight: 700;
              color: #667eea;
            }
          }
        }
      }
    }
  }

  .status-badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    display: inline-block;

    &.status-abertas {
      background: rgba(40, 167, 69, 0.1);
      color: #28a745;
    }

    &.status-encerradas {
      background: rgba(220, 53, 69, 0.1);
      color: #dc3545;
    }

    &.status-aguardando {
      background: rgba(255, 193, 7, 0.1);
      color: #ffc107;
    }

    &.status-default {
      background: rgba(108, 117, 125, 0.1);
      color: #6c757d;
    }
  }

  // Botões de Ação
  .btn-icon {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    font-size: 12px;

    &.btn-edit {
      background: #f3e5f5;
      color: #7b1fa2;

      &:hover {
        background: #e1bee7;
      }
    }

    &.btn-delete {
      background: #ffebee;
      color: #d32f2f;

      &:hover {
        background: #ffcdd2;
      }
    }

    &.btn-download {
      background: #e3f2fd;
      color: #1976d2;
      text-decoration: none;

      &:hover {
        background: #bbdefb;
      }
    }
  }
}

// Modal Styles
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 15px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  animation: slideInUp 0.3s ease-out;
  max-height: 90vh;
  overflow-y: auto;

  .modal-header {
    padding: 20px 25px;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .modal-title {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
      display: flex;
      align-items: center;
      gap: 10px;

      i {
        color: #667eea;
      }
    }

    .modal-close {
      background: none;
      border: none;
      color: #6c757d;
      cursor: pointer;
      padding: 5px;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.3s ease;

      &:hover {
        background: #f8f9fa;
      }
    }
  }

  .modal-body {
    padding: 25px;

    .form-group {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .form-label {
        display: block;
        font-weight: 600;
        color: #495057;
        margin-bottom: 8px;
        font-size: 14px;
      }

      .form-control {
        width: 100%;
        padding: 12px 15px;
        border: 2px solid #e9ecef;
        border-radius: 8px;
        font-size: 14px;
        transition: border-color 0.3s ease, box-shadow 0.3s ease;

        &:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
        }

        &::placeholder {
          color: #6c757d;
        }
      }

      textarea.form-control {
        resize: vertical;
        min-height: 80px;
      }

      .form-text {
        display: block;
        margin-top: 5px;
        font-size: 12px;
        color: #6c757d;
      }

      .form-row {
        display: flex;
        gap: 15px;
        margin-bottom: 0;

        .form-group {
          flex: 1;
          margin-bottom: 20px;
        }
      }

      label {
        display: flex;
        align-items: center;
        gap: 5px;
        cursor: pointer;

        input[type="checkbox"] {
          width: auto;
          cursor: pointer;
        }
      }

      .form-section-title {
        margin: 20px 0 15px 0;
        padding-top: 20px;
        border-top: 2px solid #e9ecef;
        font-size: 15px;
        font-weight: 600;
        color: #495057;
        display: flex;
        align-items: center;
        gap: 8px;

        &:first-of-type {
          margin-top: 10px;
          padding-top: 0;
          border-top: none;
        }

        i {
          color: #667eea;
          font-size: 14px;
        }
      }
    }
  }

  .modal-footer {
    padding: 20px 25px;
    border-top: 1px solid #e9ecef;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &.btn-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
    }

    &:disabled {
      background: #6c757d;
      cursor: not-allowed;
      transform: none;
    }
  }

  &.btn-secondary {
    background: #6c757d;
    color: white;

    &:hover {
      background: #5a6268;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .concurso-detalhes {
    .page-header {
      padding: 20px;
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;

      .header-left {
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
      }
    }

    .concurso-content {
      .stats-grid {
        grid-template-columns: 1fr;
      }

      .tabs-container {
        .tabs-header {
          overflow-x: auto;
          
          .tab-button {
            flex: 0 0 auto;
            min-width: 120px;
          }
        }

        .tabs-content {
          padding: 20px;
        }
      }

      .info-card .card-body {
        padding: 20px;

        .info-grid {
          grid-template-columns: 1fr;
        }
      }

      .vagas-section,
      .publicacoes-section {
        .section-header {
          flex-direction: column;
          align-items: flex-start;
          gap: 15px;
        }
      }
    }
  }
}
</style>
